module.exports = "https://venezia-network.servercdn.it/static/img/arrow_flickity.svg?227923350b499382070a59adefd01974";